
import { FixSubCollectionTransferResponseItem } from "@/api/classroomTransfer";
import MBaseModal from "@/components/MBaseModal.vue";
import MButton from "@/components/MButton.vue";
import { Options, Vue } from "vue-class-component";

@Options({
  components: {
    MBaseModal,
    MButton
  },
  props: {
    results: { type: Array, required: true },
    schoolNameMap: { type: Object, required: true }
  },
  emits: ["close"]
})
export default class SubCollectionResultModal extends Vue {
  results!: FixSubCollectionTransferResponseItem[];
  schoolNameMap!: Record<string, string>;

  getStatusLabel(status: string): string {
    switch (status) {
      case "no_target":
        return "対象なし（ゾンビ生徒なし）";
      case "success":
        return "全て成功";
      case "partial_success":
        return "一部成功";
      case "all_skipped":
        return "全てスキップ（正規の生徒が存在しない）";
      case "failure":
        return "失敗";
      default:
        return status;
    }
  }

  getStatusBadgeClass(status: string): string {
    switch (status) {
      case "no_target":
        return "bg-gray-100 text-gray-700";
      case "success":
        return "bg-green-100 text-green-700";
      case "partial_success":
        return "bg-yellow-100 text-yellow-700";
      case "all_skipped":
        return "bg-gray-100 text-gray-700";
      case "failure":
        return "bg-red-100 text-red-700";
      default:
        return "bg-gray-100 text-gray-700";
    }
  }

  getFailedZombieCount(result: FixSubCollectionTransferResponseItem): number {
    const processed = result.processedZombieCount ?? 0;
    const succeeded = result.succeededZombieCount ?? 0;
    return processed - succeeded;
  }

  /**
   * 処理対象があり成功したが、実際にコピーしたドキュメントが0の場合
   * （既に移動済みのケース）
   */
  isAlreadyProcessed(result: FixSubCollectionTransferResponseItem): boolean {
    const processed = result.processedZombieCount ?? 0;
    const succeeded = result.succeededZombieCount ?? 0;
    const copied = result.copiedDocCount ?? 0;
    return processed > 0 && succeeded > 0 && copied === 0;
  }
}
